import React from 'react';
import { useOrganizationClientRecords } from '../../../../../../../hooks/api/useOrganizationClientRecords';
import { useIsDisabledByParent } from '../../../../../../v2BaseComponents/IsDisabledProvider';
import { Form } from '../../../../../../v2BaseComponents/Form';
import { AnimateLoadedContent } from '../../../../../../v2BaseComponents/Loader';
import AddClientRecordFields, {
    formValueToCreateRequest,
    initialFormValue,
} from '../../../../../../shared/ClientRecord/ClientRecordFields';
import SideDrawerFormContainer, {
    ConfirmDirtyStateFormCloseContainer,
    SideDrawerDirtyFormExitValidationTracker,
} from '../../../../../../v2BaseComponents/Form/SideDrawerFormContainer';

export type AddClientRecordSideDrawerContentOwnProps = {
    onClose: (force: boolean) => void;
};

export type AddClientRecordSideDrawerContentProps = AddClientRecordSideDrawerContentOwnProps;

const AddClientRecordSideDrawerContent: React.FC<AddClientRecordSideDrawerContentProps> = (props) => {
    const { createClientRecord, isCreatingClientRecord } = useOrganizationClientRecords({
        onCreateClientRecordSuccess: () => props.onClose(false),
    });
    const isDisabled = useIsDisabledByParent(isCreatingClientRecord);
    return (
        <AnimateLoadedContent isLoading={isCreatingClientRecord}>
            {() => (
                <ConfirmDirtyStateFormCloseContainer>
                    <Form
                        fillContainer
                        initialValues={initialFormValue}
                        onSubmit={(values) => {
                            const request = formValueToCreateRequest(values);
                            createClientRecord(request);
                        }}
                        isDisabled={isDisabled}
                        forceStackFields
                    >
                        {({ isSubmitting, handleSubmit }) => {
                            return (
                                <SideDrawerFormContainer
                                    isDisabled={isDisabled || isSubmitting}
                                    onSubmit={handleSubmit}
                                    onCancel={() => props.onClose(true)}
                                >
                                    <SideDrawerDirtyFormExitValidationTracker />
                                    <AddClientRecordFields />
                                </SideDrawerFormContainer>
                            );
                        }}
                    </Form>
                </ConfirmDirtyStateFormCloseContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddClientRecordSideDrawerContent);
